import GradesModal from './GradesModal.vue'

export default GradesModal
